import { motion } from "framer-motion";
import { MessageCircle, ShoppingBag } from "lucide-react";
import { COMBOS } from "../data/menu";
import { LINKS } from "../config";
import { useLang } from "../i18n";

const waLink = (name, price) =>
  `https://wa.me/97333888070?text=${encodeURIComponent(`Hello Sipsation! I'd like to order the "${name}" combo (BD ${price}).`)}`;

const waLinkAr = (name, price) =>
  `https://wa.me/97333888070?text=${encodeURIComponent(`مرحباً سبسيشن! أود طلب توليفة "${name}" (${price} د.ب).`)}`;

export const Combos = () => {
  const { t, isAr } = useLang();
  return (
    <section id="picks" className="py-24 md:py-32 bg-forest relative overflow-hidden" data-testid="combos-section">
      <div className="absolute -top-24 -end-24 w-96 h-96 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="flex flex-wrap items-end justify-between gap-6 mb-14"
        >
          <div>
            <p className="text-xs uppercase tracking-[0.35em] text-gold font-semibold mb-4">{t.combos.kicker}</p>
            <h2 className="font-cinzel font-medium text-3xl md:text-5xl text-paper tracking-wide">
              {t.combos.titleA} <span className="font-display italic font-light text-gold-shimmer tracking-tight">{t.combos.titleB}</span>
            </h2>
          </div>
          <p className="text-paper/60 text-sm max-w-sm">{t.combos.sub}</p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="combos-grid">
          {COMBOS.map((c, i) => {
            const save = (parseFloat(c.was) - parseFloat(c.price)).toFixed(3);
            const name = isAr ? c.ar : c.en;
            const tag = isAr ? c.tagAr : c.tagEn;
            return (
              <motion.article
                key={c.id}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className="group bg-pine/40 border border-paper/10 hover:border-gold/60 p-8 flex flex-col transition-colors duration-500"
                data-testid={`combo-card-${c.id}`}
              >
                <div className="flex items-start justify-between gap-3 min-h-[28px]">
                  {tag ? (
                    <span className="text-[9px] uppercase tracking-[0.25em] bg-gold text-forest font-bold px-3 py-1.5">{tag}</span>
                  ) : (
                    <span />
                  )}
                  <span className="text-[10px] uppercase tracking-[0.2em] text-paper/40">{`0${i + 1}`}</span>
                </div>
                <h3 className="font-display text-2xl md:text-3xl text-paper mt-6 leading-tight md:min-h-[76px] group-hover:text-gold transition-colors duration-300">
                  {name}
                </h3>
                <p className="text-paper/60 text-sm mt-3 leading-relaxed flex-1">{isAr ? c.itemsAr : c.itemsEn}</p>
                <div className="mt-8 flex items-baseline gap-3 flex-wrap">
                  <span className="text-gold font-body font-bold text-2xl" dir="ltr">{c.price}</span>
                  <span className="text-[10px] uppercase tracking-[0.2em] text-paper/50">{t.combos.currency}</span>
                  <span className="text-paper/40 text-sm line-through" dir="ltr">{c.was}</span>
                  <span className="text-[10px] uppercase tracking-[0.15em] text-heart bg-paper/95 px-2 py-1 font-bold" dir="ltr">
                    {t.combos.save} {save}
                  </span>
                </div>
                <div className="mt-6 flex flex-col gap-3">
                  <a
                    href={isAr ? waLinkAr(c.ar, c.price) : waLink(c.en, c.price)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`combo-whatsapp-${c.id}`}
                    className="flex items-center justify-center gap-2 bg-gold text-forest font-semibold text-[11px] uppercase tracking-[0.18em] px-4 py-3.5 hover:bg-paper transition-colors duration-300"
                  >
                    <MessageCircle size={14} /> {t.combos.order}
                  </a>
                  <a
                    href={LINKS.talabat}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`combo-talabat-${c.id}`}
                    className="flex items-center justify-center gap-2 border border-paper/20 text-paper/80 text-[11px] uppercase tracking-[0.18em] px-4 py-3 hover:border-gold hover:text-gold transition-colors duration-300"
                  >
                    <ShoppingBag size={14} /> {t.combos.talabat}
                  </a>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
